import { Injectable } from '@angular/core';
// rxjs
import { BehaviorSubject, Observable } from 'rxjs';
// services
import { RestaurantService } from '../services/restaurant.service';
import { Merchant, RewardTiers } from '../models/restaurant.model';
import { MerchantService } from '../services/merchant.service';
import { CartStore } from './cart.store';
import { RestaurantStore } from './restaurant.store';
import { STONE_CREEK_MERCHANT_ID } from '../constants';

@Injectable()
export class MerchantStore {
  private _merchantData$ = new BehaviorSubject<Merchant>(null);
  private _merchant$ = new BehaviorSubject<Merchant>(null);
  private _merchantIsAvailable$ = new BehaviorSubject<boolean>(true);
  private _loyaltyProgram$ = new BehaviorSubject<any>(null);

  public get merchantData$(): Observable<Merchant> {
    return this._merchantData$.asObservable();
  }

  public get merchantIsAvailable$(): Observable<boolean> {
    return this._merchantIsAvailable$.asObservable();
  }

  public get loyaltyProgram$(): Observable<RewardTiers> {
    return this._loyaltyProgram$.asObservable();
  }

  constructor(
    private merchantService: MerchantService,
    private restaurantService: RestaurantService,
    private cartStore: CartStore,
    private restaurantStore: RestaurantStore
  ) {
  }

  public bootstrapMerchant(id: string): void {
    this.restaurantService.getMerchantById(id).subscribe(
      (merchant) => {
        this._merchant$.next(merchant);
        this.setMerchantIsAvailable(merchant.available);
      },
      () => {
        this.setMerchantIsAvailable(false);
      }
    );
  }

  public getMerchantData(merchantId: string): void {
    this.merchantService.getMerchantData(merchantId).subscribe((merchant) => {
      this._merchantData$.next(merchant);
    });
  }

  public setMerchantIsAvailable(value: boolean) {
    this._merchantIsAvailable$.next(value);
  }

  public getLoyaltyProgram(merchantId: string): void {
    if (merchantId === STONE_CREEK_MERCHANT_ID) {
      this.merchantService.getLoyaltyProgram(merchantId).subscribe((loyalty) => {
        this.cartStore.isLoyaltyProgramEnabled = true;
        this._loyaltyProgram$.next(loyalty);
        this.cartStore.isLoyaltyEnabled = true;
      });
    }
  }

  public bootstrapRestaurantData(merchantId: string): void {
    this.bootstrapMerchant(merchantId);
    this.restaurantStore.bootstrapRestaurants(merchantId);
    this.getMerchantData(merchantId);
    this.getLoyaltyProgram(merchantId);
  }
}
